<template>
  <v-card :class="'mx-1 my-2 py-7 pr-4 pl-6 strategy-card'"
          :style="cardStyle"
          @click="goToDetailsPage()"
  >
    <div style="height: 100%">
      <v-card-text v-if="cardItem.category" class="strategy-type px-0 pt-0 pb-0">
        {{ cardItem.category.name }}
      </v-card-text>
      <v-card-title class="align-content-start strategy-name px-0 pt-2"
                    style="line-height: 1.20!important;">
        {{ cardItem.name }}
      </v-card-title>
      <v-card-text class="px-0 pt-0 pb-0 strategy-teaser"
                   :style="teaserHeight">
        <span v-html="cardItem.description"/>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>

export default {
  name: "FinStrategyInfoCard",
  props: {
    /** The item to display, must contain at least the attributes: id, name, isLexikonCard */
    cardItem: {
      type: Object,
      required: true
    },
    /** The router navigation object to execute on card item click */
    clickNavigation: {
      type: Object
    },
    /** Nr of visible teaser lines */
    teaserLines: {
      type: Number,
      default: 6
    }
  },
  computed: {
    cardStyle() {
      let borderColor = 'transparent'
      if (this.cardItem.category) {
        borderColor = this.$finStrategyColors.find(sc => sc.type === this.cardItem.category.id)?.color || 'transparent'
      }

      return {
        borderTop: '6px solid ' + borderColor,
        backgroundColor: this.$finColors.primaryLight,
        width: (this.$vuetify.breakpoint.smAndDown ? 255 : 275) + 'px'
      }
    },
    teaserHeight() {
      const lineHeight = 19
      return {
        height: lineHeight * this.teaserLines + 'px'
      }
    }
  },
  methods: {
    goToDetailsPage() {
      if (this.clickNavigation) {
        this.$router.push(this.clickNavigation)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  &:link, &:visited, &:hover, &:active {
    text-decoration: none;
  }
}

.strategy-card {
  box-shadow: $fin-color-card-shadow !important;
  border: 1px solid $fin-color-light-sky-blue;
}

.strategy-type {
  font-size: 12px !important;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 1px;
  line-height: 1.17 !important;
  color: $fin-color-cool-grey !important;
  text-transform: uppercase;
}

.strategy-name {
  font-size: 18px !important;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  height: 68px;
}

.strategy-teaser {
  font-size: 14px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-overflow: ellipsis;
  line-height: 19px !important;
  position: relative;
  overflow: hidden;
}

.strategy-teaser::before {
  position: absolute;
  content: "...";
  background-color: white;
  padding-left: 3px;
  padding-right: 13px;
  right: 0;
  bottom: 0;
}
</style>
